import http, { Http } from '@/lib/http';

function updateVideoStatusCtor(http: Http) {
  return async (projectId: string): Promise<void> => {
    await http.patch(`/onboarding/v1/${projectId}/welcome-video`);
  };
}

export const updateVideoStatus = updateVideoStatusCtor(http);
